var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIconMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.30273V19.5002C30.0001 20.6481 29.5615 21.7525 28.7741 22.5876C27.9866 23.4227 26.9098 23.9254 25.764 23.9927L25.5 24.0002H4.5C3.35218 24.0003 2.24773 23.5617 1.41261 22.7743C0.57749 21.9869 0.0748387 20.9101 0.00750017 19.7642L0 19.5002V5.30273L14.1675 14.7482L14.3415 14.8472C14.5466 14.9474 14.7718 14.9995 15 14.9995C15.2282 14.9995 15.4534 14.9474 15.6585 14.8472L15.8325 14.7482L30 5.30273Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5005 0C27.1205 0 28.541 0.855 29.333 2.1405L15.0005 11.6955L0.667969 2.1405C1.04416 1.52973 1.5609 1.01775 2.17513 0.647234C2.78935 0.276718 3.48325 0.0584059 4.19897 0.0105L4.50047 0H25.5005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconMsg);
export default __webpack_public_path__ + "static/media/FooterIcon-Msg.67890f4a84adcaa7d400be5fda834be6.svg";
export { ForwardRef as ReactComponent };